<script>
import { mapActions, mapGetters } from 'vuex';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const mexicoDate = new Date().toLocaleDateString('en-CA', {
    timeZone: 'America/Mexico_City'
});

export default {
    props: {
        prop_edit: { default: true }
    },
    components: { DatePicker },
    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},
            send: false,
            form: {
                date: mexicoDate,
                company_id: '',
                user_id: '',
                bank_account_id: '',
                amount: 0,
                reference: '',
                description: '',
                checks: [],
                authorize: false,
            },
        }
    },
    computed: {
        ...mapGetters({ authUser: 'auth/user' }),
        totalChecksAmount() {
            const total = (this.form.checks || []).reduce((acc, row) => {
                const n = Number(row.amount_payable ?? row.amount ?? 0);
                return acc + (isNaN(n) ? 0 : n);
            }, 0);
            return Number(total.toFixed(2));
        }
    },
    methods: {
        async authorizeAndSave() {
            this.form.authorize = true;
            await this.saveTransfer();
        },

        closedModal() {
            this.errors = {};
            this.send = false;
            this.form.date = mexicoDate;
            this.form.company_id = '';
            this.form.user_id = '';
            this.form.bank_account_id = '';
            this.form.reference = '';
            this.form.description = '';
            this.form.checks = [];
            this.form.authorize = false;

            this.$modal.hide('addPayGroupTransferFast');
        },

        onFileChange(e, key) {
            const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
            this.form[key] = file;
        },

        async saveTransfer() {
            let pass = true;

            if (this.form.authorize) {
                const result = await this.$swal.fire({
                    title: '¿Está seguro de que desea autorizar la transferencia?',
                    text: 'Esta acción no puede deshacerse',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí',
                    cancelButtonText: 'No',
                    reverseButtons: true
                });

                pass = result.isConfirmed;
                if (!pass) this.form.authorize = false;
                if (!result.isConfirmed) return false;
            }

            this.send = true;

            const data_form = new FormData();
            data_form.append('date', this.form.date);
            data_form.append('type_payment', 2);
            data_form.append('company_id', this.form.company_id);
            data_form.append('user_id', this.form.user_id);
            data_form.append('bank_account_id', this.form.bank_account_id);
            data_form.append('amount', String(this.totalChecksAmount));
            data_form.append('reference', this.form.reference);
            data_form.append('description', this.form.description);
            data_form.append('authorize', this.form.authorize ? 1 : 0);

            data_form.append('checks', JSON.stringify(this.form.checks));

            let _endpoint = '/bank_transfers/update_group';
            if (this.form.authorize) _endpoint = '/bank_transfers/pay_group';

            try {
                let { data } = await request.postMedia(_endpoint, data_form);
                if (data) {
                    this.successNotification(data.message || 'Transferencia guardada');
                    this.closedModal();
                    Event.$emit('event-load-checks');
                    this.send = false;
                }
            } catch (error) {
                this.errors = {};
                if (error.response) this.errors = await this.errorNotification(error);
                this.send = false;
            }
        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },

    async created() {
        Event.$on("event-show-showPayGroupTransferFast", async (search, checks) => {
            console.log(search);
            console.log(checks);
            this.form.company_id = search.company_id;
            this.form.user_id = search.user_id;
            await this.catalogue.get_bank_accounts_companys(this.form.company_id);
            this.form.checks = checks;
            this.$modal.show('addPayGroupTransferFast');
        });
    }
}
</script>

<template>
    <modal name="addPayGroupTransferFast" :width="'80%'" :maxHeight="420" :adaptive="true" :maxWidth="900"
        :height="'auto'">

        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
            <i class="fa-solid fa-xmark"></i>
        </button>

        <form @submit.prevent="saveTransfer" method="post" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title">Pago rápido (Transferencia)</h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <div class="col-md-6 mt-2">
                        <label>Fecha de pago</label>
                        <date-picker v-model="form.date" :disabled="!prop_edit" valueType="format"></date-picker>
                        <div v-if="errors && errors.date" class="text-danger">{{ errors.date[0] }}</div>
                    </div>

                    <div class="col-md-6 mt-2">
                        <label>Cuenta bancaria</label>
                        <select class="form-control" v-model="form.bank_account_id" :disabled="!prop_edit">
                            <option value="">Seleccione</option>
                            <option v-for="(acc, i) in catalogue.bank_accounts_companys" :key="i" :value="acc.id">
                                <!-- ajusta según tu estructura -->
                                {{ acc.bank ? acc.bank.name + ' - ' : '' }} {{ acc.number }}
                            </option>
                        </select>
                        <div v-if="errors && errors.bank_account_id" class="text-danger">{{ errors.bank_account_id[0] }}
                        </div>
                    </div>

                    <div class="col-md-6 mt-2">
                        <label>Monto total</label>
                        <input class="form-control" :value="totalChecksAmount" disabled />
                    </div>

                    <div class="col-md-6 mt-2">
                        <label>Referencia</label>
                        <input class="form-control" v-model="form.reference" :disabled="!prop_edit" maxlength="150" />
                        <div v-if="errors && errors.reference" class="text-danger">{{ errors.reference[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <label>Descripción</label>
                        <textarea class="form-control" v-model="form.description" :disabled="!prop_edit"
                            rows="2"></textarea>
                        <div v-if="errors && errors.description" class="text-danger">{{ errors.description[0] }}</div>
                    </div>


                    <div class="col-md-12 mt-2">
                        <hr>
                    </div>

                    <div class="col-md-12" v-for="(check, index) in form.checks" :key="index">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <strong>Monto:</strong> {{ check.amount_payable | toCurrency }}
                                    </div>
                                    <div class="col-md-6">
                                        <strong>Descripción:</strong> {{ check.description }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 mt-2">
                        <hr>
                        <!-- 
                        <button type="submit" v-if="prop_edit && !form.authorize" :disabled="send"
                            class="btn float-right btn-outline-success mr-2">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-save"></i> Guardar
                            </span>
                        </button> -->

                        <button type="button" v-if="prop_edit && !send" class="btn float-right btn-outline-success"
                            @click="authorizeAndSave()">
                            <span v-if="send">
                                <i class="fa-solid fa-circle-notch fa-spin"></i> Guardando
                            </span>
                            <span v-else>
                                <i class="fas fa-check"></i> Autorizar
                            </span>
                        </button>

                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i> Regresar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>
